import { useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { ShieldAlert } from 'lucide-react';

// Aprobación a criterio del administrador cuando faltan documentos o datos bancarios.
export const ApproveWithoutDocs = ({ sellerId, bankingSaved, onDone }) => {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/sellers/${sellerId}/approve`, { override_missing_documents: true, note: note.trim() });
      toast.success('Vendedor aprobado a criterio del administrador');
      setOpen(false); setNote('');
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo aprobar');
    } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <Button variant="outline" className="rounded-none border-amber-400 text-amber-800 hover:bg-amber-50"
        onClick={() => setOpen(true)} data-testid="admin-approve-without-docs-btn">
        <ShieldAlert className="mr-2 h-4 w-4" /> Aprobar sin documentos
      </Button>
    );
  }
  return (
    <div className="w-full border border-amber-300 bg-amber-50 p-3 space-y-2" data-testid="admin-approve-without-docs-form">
      <div className="text-sm font-semibold text-amber-900">Aprobar sin documentos completos</div>
      <p className="text-xs text-amber-800">
        La decisión queda registrada en la auditoría con tu usuario y el motivo. Los documentos adjuntos siguen visibles y pueden revisarse después.
        {!bankingSaved && ' Sin cuenta bancaria registrada, sus pagos quedarán retenidos.'}
      </p>
      <Textarea rows={2} className="rounded-none text-sm bg-white" placeholder="Motivo de la aprobación (obligatorio)"
        value={note} onChange={(e) => setNote(e.target.value)} data-testid="admin-approve-without-docs-note" />
      <div className="flex gap-2">
        <Button className="rounded-none bg-amber-700 hover:bg-amber-800" disabled={busy || note.trim().length < 5}
          onClick={submit} data-testid="admin-approve-without-docs-confirm">Confirmar aprobación</Button>
        <Button variant="outline" className="rounded-none" onClick={() => setOpen(false)}
          data-testid="admin-approve-without-docs-cancel">Cancelar</Button>
      </div>
    </div>
  );
};
